import { createUseStyles } from '@glu/theming';

const styles = ({ schedulerReact }) => ({
  yearly: {
    marginBottom: 15
  },
  daySelect: {
    width: 70,
    display: 'inline-block',
    marginLeft: 10
  },
  monthSelect: {
    width: 'calc(100% - 80px)',
    display: 'inline-block'
  },
  datePicker: {
    display: 'inline-block',
    width: props => (
      props.canSetTime
        ? props.timePicker24Hour
          ? props.showingMultipleDays
            ? 'calc(100% - 135px)'
            : 'calc(100% - 86px)'
          : props.showingMultipleDays
            ? 'calc(100% - 201px)'
            : 'calc(100% - 161px)'
        : props.showingMultipleDays
          ? 'calc(100% - 40px)'
          : '100%'
    ),
    paddingRight: props => (
      props.canSetTime || props.showingMultipleDays ? 10 : 0
    )
  },
  timePicker: {
    display: 'inline-block'
  },
  dates: {
    marginBottom: -20
  },
  removeBtn: {
    padding: [7, 5],
    marginLeft: 10,
    '& svg': {
      fill: 'white',
      top: 2,
      position: 'relative'
    }
  },
  addBtn: {
    marginTop: 20,
    ...schedulerReact.addButton
  },
  addBtnText: {
    ...schedulerReact.addBtnText
  },
  addBtnIcon: {
    ...schedulerReact.addBtnIcon
  }
});

export default createUseStyles(styles);
